import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import type { Window } from './types';

dayjs.extend(utc);

/**
 * The instant a window becomes overdue. `WindowDue` is midnight at the start
 * of the due day but means "due through the end of that day", so the overdue
 * boundary is the following midnight UTC (exclusive): an occurrence is overdue
 * when `now >= windowOverdueAt(window)`. Any configured grace (e.g.
 * `TimeToComplete`) is the consumer's to add on top.
 *
 * This is the single implementation of the end-of-day contract — consumers
 * must not re-derive it from the raw `WindowDue` value.
 */
export const windowOverdueAt = (window: Window): Date =>
  dayjs.utc(window.WindowDue).add(1, 'day').startOf('day').toDate();
